/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var KonturBonusSignIcon24Solid = forwardRef('KonturBonusSignIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12.75 1.25a1.25 1.25 0 1 0-2.5 0V4h-3A2.25 2.25 0 0 0 5 6.25v11.5A2.25 2.25 0 0 0 7.25 20h3v2.75a1.25 1.25 0 1 0 2.5 0V20h1.5a4.75 4.75 0 1 0 0-9.5H7.5v-4h9a1.25 1.25 0 1 0 0-2.5h-3.75V1.25ZM7.5 17.5V13h6.75a2.25 2.25 0 0 1 0 4.5H7.5Z" })));
});
